import { useState } from "react";
import { Loader2, Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { api, errMsg } from "../lib/api";

const draft = (item) => ({
  subject: `Thanks for your feedback about ${item.business_name}`,
  message: `Hi ${item.customer_name || "there"},\n\n`,
});

export const ContactCustomerDialog = ({ item, onContacted }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(draft(item));
  const [sending, setSending] = useState(false);

  const change = (v) => { setOpen(v); if (v) setForm(draft(item)); };
  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post(`/business/feedback/${item.id}/contact`, form);
      toast.success(`Email sent to ${item.customer_email}`);
      onContacted(item.id, data);
      setOpen(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={change}>
      <DialogTrigger asChild>
        <button className="btn-primary !py-2" data-testid={`contact-customer-button-${item.id}`}>
          <Mail className="w-4 h-4" />Contact customer now
        </button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl sm:max-w-lg" data-testid="contact-customer-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Email {item.customer_name || "this customer"}</DialogTitle>
          <DialogDescription>Their reply will come straight to your inbox.</DialogDescription>
        </DialogHeader>
        <form onSubmit={send} className="space-y-3">
          <div className="rounded-xl bg-slate-50 border border-slate-200 px-3.5 py-2.5 text-sm" data-testid="contact-to-field">
            <span className="text-[#778580]">To: </span><span className="font-semibold">{item.customer_email}</span>
          </div>
          <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} maxLength={150} required
            className="input-base" placeholder="Subject" data-testid="contact-subject-input" />
          <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} rows={7} maxLength={5000} required
            className="input-base resize-none" placeholder="Write your message…" data-testid="contact-message-input" />
          <button type="submit" disabled={sending || !form.message.trim()} className="btn-primary w-full justify-center !py-3" data-testid="contact-send-button">
            {sending ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Send className="w-4 h-4" />Send email</>}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
